import React from 'react'
import { Document } from '@contentful/rich-text-types'
import { TextBlock, Type } from '@/components/common'
import ApplyButton from '../ApplyButton'
import { ContentBlock } from '../types'

export interface Props {
  title: string
  text: Document
  formUrl: string
  items: ContentBlock[]
  className?: string
}

const Pricing: React.FC<Props> = ({
  title,
  text,
  formUrl,
  items,
  className,
}) => {
  return (
    <div className={className}>
      <div className="mx-auto flex max-w-[1360px] flex-col px-6 md:flex-row md:items-center md:px-8">
        <div className="w-full md:w-1/2 md:pr-12 lg:pr-16 xl:pr-24">
          <Type as="h2" variant="heading-sm" className="mb-6">
            {title}
          </Type>

          <TextBlock document={text} />

          <ApplyButton url={formUrl} className="mt-4 lg:mt-6" />
        </div>

        <div className="mt-8 flex w-full flex-col rounded-lg border border-core-gray-300 bg-white md:mt-0 md:w-1/2 lg:flex-row">
          {items.map(({ id, title, subtitle, text }) => (
            <div key={id} className="p-6 pb-2 lg:w-1/2 lg:p-12">
              <Type as="h3" variant="heading-lg">
                {title}
              </Type>

              <Type
                as="h3"
                variant="eyebrow-md"
                className="mb-4 text-gray lg:mb-8"
              >
                {subtitle}
              </Type>

              <TextBlock document={text} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Pricing
